// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"447":"7908f0f4","677":"7908f0f4"}[chunkId] + ".chunk.css";
};